import React from 'react'
import './video-embed.css'

const SOURCES = [
    'youtube',
    'vimeo'
]

export default function VideoEmbed({ src }) {
    // NOTE: At time of writing (July 2019), it is assumed that all video embeds will have a source of YouTube. A prop may be added moving forrward to facilitate 
    // handling of different video hosting sites if needed

    let type = ''
    SOURCES.map(source => {
        if (src.indexOf(source) !== -1) {
            return type = source
        }
        return null
    })

    if (type === 'youtube') {
        return (
            <div className='video-responsive'>
                <iframe width="560"
                    title={src}
                    height="315" 
                    src={`${ src }?rel=0`}
                    frameBorder="0" 
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" 
                    allowFullScreen
                />
            </div>
        )
    }

    if (type === 'vimeo') {
        return (
            <div className='video-responsive'>
                <iframe 
                    title={src}
                    src={`${ src }`} 
                    width="" 
                    height="480" 
                    frameBorder="0" 
                    allow="autoplay; fullscreen" 
                    allowFullScreen
                />
            </div>
        )
    }

    return null

    
}